<template>
  <div class="componentWrap">
    <div class="selectWrap" v-if="selectedList.length !== 0 && !isExcel">
      <span><v-icon>find_in_page</v-icon>{{labelText}}</span>
      <select v-model="optionVal" @change="changeOption" class="select_content">
        <option disabled value="">Please select one</option>
        <option v-for="(data, n) in selectedList" :value="data.name" :key="n">
          {{data.name}}
        </option>
      </select>
    </div>
    <table class="bottom" v-if="selectedList.length !== 0" :id="excelId">
      <thead>
        <tr>
          <th class="botTableHeader" rowspan="2">날짜</th>
          <th class="botTableHeader" colspan="4">{{selectedData.name}}</th>
        </tr>
        <tr>
          <th class="botTableHeader" v-for="(header, n) in headers" :key="n">{{header}}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(data, index) in dataList" :class="[existCheck(data) ? '' : '_notExist']" :key="index">
          <td class="ymd_wrap sortCenter">
              {{data.ymd}}
          </td>
          <td class="dataTd">
            <div class="bot_dataWrap">
              {{parseDataType(data.imp_cnt)}}
            </div>
          </td>
          <td class="dataTd">
            <div class="bot_dataWrap">
              {{parseDataType(data.click_cnt)}}
            </div>
          </td>
          <td class="dataTd">
            <div class="bot_dataWrap">
              {{data.ctr === 0 ? 0 : data.ctr.toFixed(2)}}
            </div>
          </td>
          <td class="dataTd" v-if="tab === 'contract' || tab === 'creativeGroup'">
            <div class="bot_dataWrap">
              {{parseDataType(data.budget_amt)}}
            </div>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <th class="content_total">합계</th>
          <th class="content_total">
            <div class="bot_dataWrap">
              {{parseDataType(selectedData.imp)}}
            </div>
          </th>
          <th class="content_total">
            <div class="bot_dataWrap">
              {{parseDataType(selectedData.click)}}
            </div>
          </th>
          <th class="content_total">
            <div class="bot_dataWrap">
              {{selectedData.ctr.toFixed(2)}}
            </div>
          </th>
          <th class="content_total" v-if="tab === 'contract' || tab === 'creativeGroup'">
            <div class="bot_dataWrap">
              {{parseDataType(selectedData.budget_amt)}}
            </div>
          </th>
          <!--상품/일자별 리포트 마지막 합계-->
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
  import { parseDataType, parseDateFormat } from '@/assets/func'
  import { mapState, mapGetters } from 'vuex'

  export default {
    name: 'tableByContent',
    props: {
      // data props
      headers: Array,
      tab: String,
      isExcel: Boolean,
      num: Number
      // function props
    },
    data () {
      return {
        optionVal: '',
        selected: '',
        selectLabel: [
          '상품/일자별 리포트',
          '사이즈/일자별 리포트',
          '소재/일자별 리포트',
          '소재그룹/일자별 리포트',
          '지역/일자별 리포트'
        ]
      }
    },
    methods: {
      changeOption (e) { // 우측하단 개별 테이블 데이터 선택
        this.selected = e.target.value.trim()
      },
      existCheck (data) {
        let cValue = ''
        switch (this.tab) {
          case 'creative':
            cValue = 'creative_nm'
            break
          case 'creativeGroup':
            cValue = 'group_nm'
            break
          case 'size':
            cValue = 'size_nm'
            break
          case 'geo':
            cValue = 'geo_nm'
            break
          default :
            cValue = 'ad_knd_nm'
            break
        }
        return data[cValue] !== null
      },
      parseDataType (data) {
        return parseDataType(data)
      }
    },
    computed: {
      ...mapState({
        currentAdKnd: state => state.campaign.currentAdKnd
      }),
      ...mapGetters([
        'contentImpData'
      ]),
      contentData () {
        return this.contentImpData(this.tab)
      },
      dataList () {
        let list = this.selectedData.data
        let toDay = new Date()

        list = list.filter(function (data) {
          let date = parseDateFormat(data.ymd)
          date = new Date(date)
          let isEqual = !(date.getFullYear() === toDay.getFullYear() && date.getMonth() === toDay.getMonth() && date.getDate() === toDay.getDate())
          return (date < toDay && isEqual)
        })
        return list
      },
      labelText () {
        switch (this.tab) {
          case 'contract':
            return this.selectLabel[0]
          case 'size':
            return this.selectLabel[1]
          case 'creative':
            return this.selectLabel[2]
          case 'creativeGroup':
            return this.selectLabel[3]
          case 'geo':
            return this.selectLabel[4]
        }
      },
      selectedList () {
        if (this.currentAdKnd === null) return [this.contentData[0]]
        let text = this.currentAdKnd
        let data
        if ((this.tab === 'size') && !this.isExcel) {
          data = this.contentData.filter(function (content) {
            return content.name.split(' ')[1] === text
          })
        } else if ((this.tab === 'geo') && !this.isExcel) {
          data = this.contentData.filter(function (content) {
            let geoLength = content.name.split(' ').length
            geoLength -= 1
            return content.name.split(' ')[geoLength] === text
          })
        } else {
          data = this.contentData
        }
        if (data[0] === undefined) {
          return [{name: '', data: [], imp: 0, click: 0, ctr: 0, budget_amt: 0}]
        }
        this.selected = data[0].name
        this.optionVal = data[0].name
        return data
      },
      selectedData () { // 선택된 옵션별 데이터 변경
        if (this.isExcel) {
          return this.selectedList[this.num]
        }
        let selected = this.selected === '' ? this.selectedList[0].name : this.selected
        let result = this.selectedList.filter(function (content) {
          if (content.name === null) return ' '
          return content.name.trim() === selected
        })
        return result[0]
      },
      excelId () {
        if (this.isExcel) {
          return this.tab + this.num
        }

        return ''
      }
    },
    beforeUpdate () {
      let val = this.optionVal
      let isChange = this.selectedList.filter(function (data) {
        return val === data.name
      })
      if (isChange.length === 0) this.optionVal = this.selectedList[0].name
    },
    mounted () {
      if (this.contentData.length !== 0) {
        this.optionVal = this.selectedList[0].name
      }
    }
  }
</script>

<style scoped>
  .componentWrap {
    margin-right: 0 !important;
  }
  .bottom {
    border-collapse: collapse !important;
    width: 100%;
    border-spacing: 0;
  }
  .dataTd:first-child>div {
    min-width: 150px;
    margin-left: 10px;
    text-align: left;
  }
  .selectWrap {
    position: absolute;
    width: calc(100% - 5px);
    display: flex;
    justify-content: space-between;
    height: 25px;
    line-height: 25px;
    top: -29px;
    left: 5px;
  }
  .selectWrap i {
    vertical-align: middle;
    font-weight: 500;
    margin-right: 3px;
  }
  .selectWrap span {
    color: #689f38;
    font-weight: 500;
    margin-right: 3px;
    vertical-align: middle;
    min-width: 60px;
  }
  .selectWrap select {
    vertical-align: middle;
    border-radius: 6px;
    height: 23px;
    padding-bottom: 3px;
  }
  .select_content:hover {
    cursor: pointer;
  }

  ._notExist {
    background: rgb(247, 249, 250);
  }
  th, td {
    height: 25px;
  }
  tr {
    border-bottom: 1px solid #eaeaea;
  }
  tbody tr:last-child {
    border-bottom: none;
  }
  tfoot th {
    border-top: 1px solid #eaeaea;
  }

  tfoot tr {
    border-bottom: none;
  }
  @media screen and (max-width: 400px) {
    .select_content {
      width: 200px !important;
    }
    .selectWrap i {
      display: none;
    }
  }
  @media screen and (max-width: 600px) {
    .componentWrap {
      padding-left: 0;
      padding-right: 0;
      margin-left: 0;
      margin-right: 0;
      width: calc(100% - 2px);
      text-align: center;
      margin-top: 40px;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .selectWrap {
      right: 5px;
      top: -30px;
      text-align: left;
    }
    .bottom {
      width: 100%;
      margin-left: 0;
      padding-bottom: 10px;
    }
    .ymd_wrap {
      width: 15px;
    }
  }
</style>


// WEBPACK FOOTER //
// ContentImp.vue?a8355b04